'use strict';

module.exports = function (x) {
	return (x && ((typeof x === 'symbol') || (x['@@toStringTag'] === 'Symbol'))) || false;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es6-symbol/is-symbol.js
 ** module id = 204
 ** module chunks = 0
 **/